export enum AdminScreen {
	Setup = 'setup',
	Publish = 'publish',
	Saved = 'saved',
	Analytics = 'analytics',
	Help = 'help',
}
